import React from 'react';
import { motion } from 'framer-motion';
import DocsLayout from '../components/DocsLayout';
import SEO from '../components/SEO';
import { FaUsb, FaShoppingCart, FaChevronRight, FaLightbulb, FaQuestionCircle, FaTools, FaCompactDisc, FaKey, FaDownload, FaWindows, FaApple, FaDesktop } from 'react-icons/fa';

// 导入本地U盘图片
import sandiskImg from '../assets/bf012f01b89ab814.jpg';
import kingstonImg from '../assets/b828e354f735161c.jpg';
import lenovoImg from '../assets/74f86f4459601d92.jpg';
import netacImg from '../assets/ab6771f8fe1d77ad.jpg';
import teclastImg from '../assets/a85272c84bfd1ebe.jpg';
import aigoImg from '../assets/c11c975a48c474b5.jpg';

interface UsbProduct {
  id: string;
  name: string;
  capacity: string[];
  description: string;
  features: string[];
  price: string;
  link: string;
  imageUrl: string;
}

const usbProducts: UsbProduct[] = [
  {
    id: 'sandisk',
    name: '闪迪（SanDisk）酷悠 USB3.0 U盘',
    capacity: ['16GB'],
    description: '闪迪酷悠系列U盘，采用创意个性伸缩设计，USB3.0接口，读取速度20MB/s，写入速度10MB/s，黑色简约外观，适合日常文件传输与系统安装使用。',
    features: [
      '黑色外壳，创意伸缩设计',
      '读取速度20MB/s，写入速度10MB/s',
      'USB 3.0接口，兼容性强',
      '带指示灯和钥匙孔设计',
      '尺寸：60mm×20mm×11.2mm'
    ],
    price: '',
    link: 'https://union-click.jd.com/jdc?e=618%7Cpc%7C&p=JF8BAScJK1olXwQAVV1dAU0UBV8MGV4XVQcAUVZbAXtTXDdWRGtMGENDFlVDFhNSVzMXQA4KD1heSlpfDUkfAm0NE10cQl9HCANtez1gaBBSRj52JBxwC14WbgJhdA1OTVcZbQcyVF9cCE4fBGkKHWslXQEyFTBbDkMSA284GmsVWwMHVF1bCUoeBW4OK1wVVDYFXFZcC0IVCnMOElkSWAEyZG5eOEwXCnsOaRpHSQBwZG5dOEgnA24IE1gQWgQEU1lBCEgXAmsNB1sTWAMCV1lVAEwUBGc4GVoUWQ8yZIDQuDQTYhRQayV-GnVbIT4BaxfJjt8ZcCIdXQYBRW46d0gQYjF-cC1VW3B2B1xcUjwSXyxyTDN7X3F0AlsvCElOdTRTXCYTWARnZFtt',
    imageUrl: sandiskImg
  },
  {
    id: 'kingston',
    name: '金士顿（Kingston）DT70 USB3.2 Gen1 Type-C U盘',
    capacity: ['64GB'],
    description: '金士顿DT70系列，采用USB-C接口设计，支持安卓和苹果手机，黑色塑料外壳，读取速度50MB/s，写入速度5MB/s，轻巧便携，车载手机电脑通用。',
    features: [
      '黑色塑料外壳',
      'USB 3.2 Gen1 Type-C接口',
      '读取速度50MB/s，写入速度5MB/s',
      '无指示灯，无钥匙孔设计',
      '尺寸：59mm×18.5mm×9mm'
    ],
    price: '',
    link: 'https://union-click.jd.com/jdc?e=618%7Cpc%7C&p=JF8BASQJK1olXDYCVV9cCksfAGkAElglGVlaCgFtUQ5SQi0DBUVNGFJeSwUIFxlJX3EIGloUXwYKV1hVAUgIWipURmtjGU5KKSsVbS5hABtOEwhXD394HCwtBEcnAl8IGloVWA4FUlxbOHsXBF9edVsUXAcDVV9dAEgnAl8IHV4QXQUEVF5UDk4eM2gIEmsSVQ4DV1dfAVcRCm0PHlwlbTYBZFldAV8RcS5aD11nbTYCZF1tCEoXC2wNGVsQXQMeVF1eAUMXH28OHl4VXgADXV1YC0InAW4JH1IlbdiP5DwpdBledi9_R1ttCXtZKB2DhfsGcR8KH10STDZKFz5cYwxgCxhMbgdGHQ4EI10HCClgWAhmGQ1MI1RdHCE1fylld2lAUzBlbQMy',
    imageUrl: kingstonImg
  },
  {
    id: 'lenovo',
    name: '联想生态异能者 F101 USB2.0 U盘',
    capacity: ['16GB'],
    description: '联想生态异能者F101系列，采用金属外壳设计，银色商务外观，USB2.0接口，读取速度25MB/s，写入速度8MB/s，小巧迷你，适合办公投标使用。',
    features: [
      '金属外壳，银色商务风格',
      '读取速度25MB/s，写入速度8MB/s',
      'USB 2.0接口',
      '带钥匙孔设计，无指示灯',
      '尺寸：38mm×12.2mm×5.9mm'
    ],
    price: '',
    link: 'https://union-click.jd.com/jdc?e=618%7Cpc%7C&p=JF8BASQJK1olXDYCVV9cDE4QAGsPH1glGVlaCgFtUQ5SQi0DBUVNGFJeSwUIFxlJX3EIGloUWQMFV1paDEgIWipURmtGHgZCMiQfTitvWyZ7blISFkJKMwsbBEcnAl8IGloVWA4FUlxbOHsXBF9edVsUXAcDVV9dDE0nAl8IHV4QXQUEV1pcC08QM2gIEmsSVQ4DV1dfAVcRCm0PHlwlbTYBZFldAV8RcS5aD11nbTYCZF1tCEoXC20PElsRXQ4eVFxeCkkWH28OHl4VXgABVllcC0MnAW4JH1IlbdiMwDpdbwN0cDx7QidMLV1KCiiDht8GfxgBGVkRTDZrLTleCjxUdyxya11jX05KDwojUTIfehtmGSJuHwd7EyQGSxZAdTZ3WCxpbQMy',
    imageUrl: lenovoImg
  },
  {
    id: 'netac',
    name: '朗科（Netac）U355 USB3.2 U盘',
    capacity: ['32GB'],
    description: '朗科U355系列，高速USB3.2接口，金属外壳设计，黑色商务风格，读取速度150MB/s，写入速度40MB/s，支持文件加密，适合办公和大容量文件传输。',
    features: [
      '金属外壳，黑色简约设计',
      '读取速度150MB/s，写入速度40MB/s',
      'USB 3.2高速接口',
      '带钥匙孔设计，无指示灯',
      '尺寸：56.5mm×17.2mm×7.5mm'
    ],
    price: '',
    link: 'https://union-click.jd.com/jdc?e=618%7Cpc%7C&p=JF8BATMJK1olXwEDXFZUDUkSBV8IGloUXA4KUFZfCU8nRzBQRQQlBENHFRxWFlVPRjtUBABAQlRcCEBdCUoWAmcAH1MXXAIdDRsBVXtVem52fCMVAmRRDEQkbBBeWmlobzNDUQoyVW5dCUoXBmcPHVkTbTYCU24fZpy6pbmeu42D_dG55V1cCEgnAl8IHV4QXQUEUVlYAE8RM2gIEmsSVQ4DV1dfAVcRCm0PHlwlbTYBZFldAV8RcS5aD11nbTYCZF1tCEoXCmsPHV8dWwceVF5ZD0kXH28OHl4VXgAAXV9aCU4nAW4JH1IlbdiMwCVeTSN_ABhyRF4TJ1l-AQuDht8GfxgMHFIVTDZXBCIbUhtoAhB3RglgH05QAlkPaUtqUDpmGQNLIQVwJlhddz9iWjZvcC12bQMy',
    imageUrl: netacImg
  },
  {
    id: 'teclast',
    name: '台电（TECLAST）镭神PLUS USB3.0 U盘',
    capacity: ['32GB'],
    description: '台电镭神PLUS系列，采用金属旋转保护设计，银色商务风格，USB3.0高速接口，读取速度100MB/s，写入速度45MB/s，适合办公和车载电脑使用。',
    features: [
      '金属外壳，银色旋转设计',
      '读取速度100MB/s，写入速度45MB/s',
      'USB 3.0高速接口',
      '带钥匙孔设计，无指示灯',
      '尺寸：57mm×17mm×10mm'
    ],
    price: '',
    link: 'https://union-click.jd.com/jdc?e=618%7Cpc%7C&p=JF8BATMJK1olXwEDUlZYDEsWCl8IGloUXAcKVFxcCUknRzBQRQQlBENHFRxWFlVPRjtUBABAQlRcCEBdCUoWAm4AG1kUXAQdDRsBVXt-CiZxYitJCGQFNishfSgVfihPcEVTUQoyVW5dCUoXBmcPHVkTbTYCU24fZhBCbWlcHVNCWQMKUAtUW00nAl8IHV4QXQUEUFtfCUkUM2gIEmsSVQ4DV1dfAVcRCm0PHlwlbTYBZFldAV8RcS5aD11nbTYCZF1tCEoXC2wIGF4VWAUeVFxfCk4WH28OHl4VXgAGVltbCEknAW4JH1IlbdiMwDgvWElvcS94XDxNK1x1ISGDht8GcR8IH1wRTDZgPBo7VwJcXiQBRQ90CVBJCj4DUQpxag5mGTtzCF5JDzc2QwNvAjheHixmbQMy',
    imageUrl: teclastImg
  },
  {
    id: 'aigo',
    name: '爱国者（aigo）U330 USB3.2 U盘',
    capacity: ['64GB'],
    description: '爱国者U330系列，新升级USB3.2接口，采用金属旋转设计，银色商务风格，读取速度高达220MB/s，写入速度50MB/s，高速耐用，适合商务办公和学习使用。',
    features: [
      '金属外壳，银色旋转设计',
      '读取速度220MB/s，写入速度50MB/s',
      'USB 3.2高速接口',
      '带钥匙孔设计，无指示灯',
      '尺寸：54.1mm×17mm×9.3mm'
    ],
    price: '',
    link: 'https://union-click.jd.com/jdc?e=618%7Cpc%7C&p=JF8BASMJK1olXwQBXVlcCEwTB18MElwdWwIHZBoCUBVIMzZNXhpXVhgcDBsJVFRMVnBaRQcLWQ8FXFhZDVRORjNVK10dIgNHDz8_aCtXBxN-fzplPlVrDBhRBHsWM28JGlsQVQEEVlhtOEsQMzlmG1oUXAcDV1pdAHsWM28OHl4VXgAEV1heCE4nBG8BK1wdVQcBXVxUFE0eAWgNHGslbQUyU15UHE1lQj0cHSklbQYyV25dCUseB2cBH1IdVRoCUVxZCEwLA2kNHlsWWwEFXFhVDXsVAm4MEmslg4uyLColeCMfCgtpTx1vDQd6FYDQuFprZ2sIGl4EbWACAgM7XDZXfhRqQ1NPKHZ-FwgYDxFURAEKazlNJn4CUCYgURJxAxpsGAAlWDY',
    imageUrl: aigoImg
  },
];

const sidebarItems = [
  { title: "装机工具", path: "/tools", icon: <FaTools /> },
  { title: "PE工具", path: "/petools", icon: <FaCompactDisc /> },
  { title: "激活工具", path: "/activators", icon: <FaKey /> },
  { title: "系统下载", path: "/downloads", icon: <FaDownload /> },
  { title: "Windows软件", path: "/windows-software", icon: <FaWindows /> },
  { title: "MacOS软件", path: "/macos-software", icon: <FaApple /> },
  { title: "安装U盘推荐", path: "/usb-recommend", icon: <FaUsb /> },
  { title: "电脑选购推荐", path: "/computer-recommend", icon: <FaDesktop /> }
];

const USBRecommend: React.FC = () => {
  return (
    <DocsLayout sidebarItems={sidebarItems}>
      <SEO 
        title="系统安装U盘推荐大全 | Win10/Win11安装最佳启动盘选购指南"
        description="精选适合系统安装的高性能U盘推荐，包括各大品牌优质U盘对比、参数和选购建议，帮你轻松选择最适合Windows系统安装的高速启动U盘。"
        keywords="装机U盘推荐,系统安装U盘,U盘选购指南,启动U盘制作,U盘品牌推荐,U盘速度对比,Win10启动盘,Win11安装U盘,高速U盘选购"
      />
      <div className="container mx-auto px-4 py-8">
        <motion.h1 
          className="text-3xl font-bold mb-6 text-gray-800"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          系统安装推荐U盘
        </motion.h1>
        
        <motion.div 
          className="mb-8 bg-blue-50 p-5 rounded-lg shadow-sm border border-blue-100"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <h3 className="text-xl font-semibold text-blue-800 mb-3 flex items-center">
            <FaLightbulb className="mr-2" /> 选购指南
          </h3>
          <p className="text-gray-700 mb-3">
            选择一个高质量的U盘对于系统安装至关重要。以下是我们精心挑选的几款U盘推荐，它们都具有以下特点：
          </p>
          <ul className="list-disc list-inside space-y-2 text-gray-700">
            <li>高速读写，减少安装等待时间</li>
            <li>稳定性好，减少安装失败概率</li>
            <li>耐用性强，支持多次系统安装</li>
            <li>容量适中，16GB以上即可满足大多数系统安装需求</li>
          </ul>
        </motion.div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {usbProducts.map((product, index) => (
            <motion.div 
              key={product.id}
              className="bg-gradient-to-br from-white to-gray-50 rounded-lg shadow-md overflow-hidden border border-gray-200 hover:shadow-lg transition-all hover:translate-y-[-2px]"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 * index }}
            >
              <div className="p-5">
                <div className="flex items-start mb-4">
                  <div className="flex-shrink-0 w-24 h-24 bg-white rounded-md overflow-hidden border border-gray-100 shadow-sm">
                    <img src={product.imageUrl} alt={product.name} className="w-full h-full object-cover" />
                  </div>
                  <div className="ml-4">
                    <h3 className="text-xl font-semibold text-gray-800">{product.name}</h3>
                    <div className="flex flex-wrap gap-1 mt-2">
                      {product.capacity.map(cap => (
                        <span key={cap} className="inline-block bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">
                          {cap}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
                
                <p className="text-gray-600 text-sm mb-4">{product.description}</p>
                
                <div className="mb-4">
                  <h4 className="font-medium text-gray-800 mb-2 flex items-center">
                    <FaLightbulb className="text-amber-500 mr-2" size={16} />
                    产品特点：
                  </h4>
                  <ul className="text-sm text-gray-600 space-y-2">
                    {product.features.map((feature, idx) => (
                      <li key={idx} className="flex items-start">
                        <FaChevronRight className="text-blue-500 flex-shrink-0 mt-1 mr-2" size={12} />
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                
                <a 
                  href={product.link} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="block w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white text-center py-2 px-4 rounded-md transition-colors font-medium shadow-sm"
                >
                  查看详情 / 购买
                </a>
              </div>
            </motion.div>
          ))}
        </div>
        
        <motion.div 
          className="mt-10 bg-yellow-50 p-5 rounded-lg shadow-sm border border-yellow-100"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.6 }}
        >
          <h3 className="text-lg font-semibold text-amber-800 mb-3 flex items-center">
            <FaQuestionCircle className="mr-2" /> U盘选购小贴士
          </h3>
          <ul className="list-disc list-inside space-y-2 text-gray-700">
            <li>容量选择：Windows 10/11安装至少需要8GB空间，建议选择16GB以上的U盘。</li>
            <li>读写速度：建议选择USB 3.0以上接口的U盘，读写速度更快，安装系统更加流畅。</li>
            <li>品牌选择：建议选择知名品牌，如SanDisk、Kingston、联想等，质量和售后有保障。</li>
            <li>用途区分：如果只是偶尔安装系统，可以选择经济实惠的型号；如果经常安装或者有其他数据传输需求，建议选择高性能U盘。</li>
          </ul>
        </motion.div>
      </div>
    </DocsLayout>
  );
};

export default USBRecommend; 